import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// inner imports
import { getDatatypes, openCategoriesModal, closeCategoriesModal } from '../../../../Actions/main';
import { saveDatatypes } from '../../../../Actions/admin';
import { CategoryCards } from '../AdminComponents/CategoryCards';
import { CategoryModal } from '../../../Modals/Category';
import { BAND, MUSICIAN, LIVE_MUSIC, SERVICE } from '../../../../consts';

// css imports
import '../mainAdminstyles.css';
import './styles.css';

class Categories extends Component {
    componentWillMount() {
        this.props.getDatatypes();
    }

    deleteCategory(name, type, index) {
        if (!window.confirm('Do really want to delete this category')) return;

        let dataTypes = JSON.parse(JSON.stringify(this.props.datatypes));
        if (!dataTypes.categories[type]) return;

        dataTypes.categories[type].splice(index, 1);
        delete dataTypes.subCategories[name];

        this.props.saveDatatypes(this.props.token, dataTypes, null, null, null, index).then(() => this.props.getDatatypes());
    }

    editCategory(category, type) {
        this.props.openCategoriesModal(type, category)
    }

    handleHideToggle(cat, type) {
        let dataTypes = JSON.parse(JSON.stringify(this.props.datatypes));

        if (!dataTypes.categories[type]) return;

        let effectedCatIndex;
        dataTypes.categories[type].forEach((c, index) => {
            if (c.name !== cat.name) return;
            effectedCatIndex = index
            c.isHidden = !c.isHidden;
        });

        this.props.saveDatatypes(this.props.token, dataTypes, null, null, null, effectedCatIndex).then(() => this.props.getDatatypes());
    }

    render() {
        return (
            <div className="admin-wrapper categories-wrapper">
                <div className="content">
                    <div className="top-bar">
                        <div className="title">Categories</div>
                    </div>
                    <div style={{height: '40px'}} />
                    <CategoryCards
                        type={LIVE_MUSIC}
                        dataTypes={this.props.datatypes}
                        onNewCardClick={this.props.openCategoriesModal}
                        onDelete={this.deleteCategory.bind(this)}
                        onEdit={this.editCategory.bind(this)}
                        onHide={(cat, type) => this.handleHideToggle(cat, type)}
                    />

                    <CategoryCards
                        type={SERVICE}
                        dataTypes={this.props.datatypes}
                        onNewCardClick={this.props.openCategoriesModal}
                        onDelete={this.deleteCategory.bind(this)}
                        onEdit={this.editCategory.bind(this)}
                        onHide={(cat, type) => this.handleHideToggle(cat, type)}
                    />

                    <CategoryCards
                        type={MUSICIAN}
                        dataTypes={this.props.datatypes}
                        onNewCardClick={this.props.openCategoriesModal}
                        onDelete={this.deleteCategory.bind(this)}
                        onEdit={this.editCategory.bind(this)}
                        onHide={(cat, type) => this.handleHideToggle(cat, type)}
                    />

                    <CategoryCards
                        type={BAND}
                        dataTypes={this.props.datatypes}
                        onNewCardClick={this.props.openCategoriesModal}
                        onDelete={this.deleteCategory.bind(this)}
                        onEdit={this.editCategory.bind(this)}
                        onHide={(cat, type) => this.handleHideToggle(cat, type)}
                    />
                </div>
                <CategoryModal
                    token={this.props.token}
                    isOpen={this.props.isCategoriesModalOpen}
                    closeModal={this.props.closeCategoriesModal}
                    datatypes={this.props.datatypes}
                    type={this.props.type}
                />
            </div>
        )
    }
}

Categories.propTypes = {
    datatypes: PropTypes.object,
    getDatatypes: PropTypes.func,
    isCategoriesModalOpen: PropTypes.bool,
    openCategoriesModal: PropTypes.func,
    closeCategoriesModal: PropTypes.func,
    type: PropTypes.string,
    token: PropTypes.string,
    saveDatatypes: PropTypes.func
};

const mapStateToProps = (state) => ({
    datatypes: state.main.datatypes,
    isCategoriesModalOpen: state.main.isCategoriesModalOpen,
    type: state.main.catType,
    token: state.users.token
});

export default connect(mapStateToProps, {
    getDatatypes,
    openCategoriesModal,
    closeCategoriesModal,
    saveDatatypes
})(Categories);



// WEBPACK FOOTER //
// ./src/Components/Screens/Admin/Categories/Categories.js